import { ComponentBase } from "@tblabs/truffle";


export class H2 extends ComponentBase<HTMLHeadingElement>
{
    constructor(text: string, klass?: string)
    {
        super("h2");

        this.Class(klass);
        this.Text(text);
    }
}
